import classNames from 'classnames';
import FlexContainer from '../FlexContainer';
import Txt from '../Txt';
import { useState } from 'react';
import View from '../View';
import styles from './Carousel.module.scss';

/**
 * Carousel
 *
 * @return {JSX.Element}
 */
const Carousel = ({
  className,
  data,
  renderItem,
  keyExtractor = ({ id }) => id,
  flex,
  index = 0,
  onChange,
  controls,
  roundTrip,
  showCounter,
  disabled,
}) => {
  const [activeIndex, setActiveIndex] = useState(index);

  const handleChange = (nextIndex) =>
    onChange ? onChange(nextIndex) : setActiveIndex(nextIndex);

  const handleChangePrev = () => {
    const maxIndex = data.length - 1;
    let nextIndex = activeIndex - 1;
    if (nextIndex < 0) {
      nextIndex = roundTrip ? maxIndex : 0;
    }
    handleChange(nextIndex);
  };
  const handleChangeNext = () => {
    const maxIndex = data.length - 1;
    let nextIndex = activeIndex + 1;
    if (nextIndex > maxIndex) {
      nextIndex = roundTrip ? 0 : maxIndex;
    }
    handleChange(nextIndex);
  };

  return (
    <View
      className={classNames(
        styles.Carousel,
        flex && styles.Carousel__flex,
        className,
        `${Carousel.displayName}`
      )}
    >
      <View
        className={styles.Scroller}
        style={{ transform: `translate(-${activeIndex * 100}%)` }}
      >
        {data.map((i) => (
          <FlexContainer alignCenter justifyContentCenter key={keyExtractor(i)}>
            {renderItem(i)}
          </FlexContainer>
        ))}
      </View>
      {controls && data.length ? (
        <>
          <button
            className={classNames(styles.Control, styles.ControlLeft)}
            onClick={handleChangePrev}
          />
          <button
            className={classNames(styles.Control, styles.ControlRight)}
            onClick={handleChangeNext}
          />
        </>
      ) : null}
      {showCounter && data.length ? (
        <View className={styles.Counter}>
          <Txt className={styles.CounterTxt}>
            {activeIndex + 1}/{data.length}
          </Txt>
        </View>
      ) : null}
    </View>
  );
};

Carousel.displayName = 'Carousel';

export default Carousel;
